import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LeaderGroupService, LeaderUserService } from '@services/leader';
import {
	LanguageService,
	MAIN_KEY_PREFIX,
	MainKey,
	StorageService,
} from '@services/public';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';

const PAGE_PATH = `pages.leader.dashboard.groupManagement.stepThree`;

@Component({
	selector: 'app-step-three',
	templateUrl: './step-three.component.html',
	styleUrls: ['./step-three.component.scss'],
})
export class StepThreeComponent implements OnInit, OnChanges, OnDestroy {
	public stepThreeForm: UntypedFormGroup;
	@Input() stepNext: string;
	@Output() submitPop = new EventEmitter<any>();
	success: any;
	memberArrey: any = [];
	assignedROle: any = [];
	selectedButton;
	selectedRole = [];
	members: any = [];
	memberRole: any;
	searchText = new UntypedFormControl('');
	memberData1: any;
	logUser: any;
	// Page language.
	page: { [key: string]: string } = {};
	private _subscriptions: Subscription = new Subscription();

	constructor(
		public bsModalRef: BsModalRef,
		private groupSvc: LeaderGroupService,
		private _storageSvc: StorageService,
		private _languageSvc: LanguageService,
		private _userSvc: LeaderUserService,
	) {}

	ngOnChanges() {
		this._userSvc.getUsers().subscribe((users) => {
			this.members = users;
			this.members.map((ele) => {
				const newPropsObj = {
					isAssign: false,
					role: '',
					img: {
						adminImg: 'assets/img/administrator-line-gray.svg',
						leaderImg: 'assets/img/leader-line-gray.svg',
					},
				};
				return Object.assign(ele, newPropsObj);
			});
			const logUser = this.members.find((user) => user.uuid === this.logUser);
			if (logUser !== undefined) {
				logUser.role = 'admin';
				logUser.isAssign = true;
				logUser.img.adminImg = 'assets/img/administrator-line-white.svg';
			}
			let organizationUUID = JSON.parse(
				localStorage.getItem('groupOrganizationUUID'),
			);
			this.members = this.members.filter(
				(user: any) => user.organizationUUID === organizationUUID,
			);
			this.members.unshift(logUser);
			this.memberData1 = this.members;
		});
	}

	ngOnInit(): void {
		this._subscriptions.add(
			this._storageSvc.updates.subscribe((update) => {
				if (update.key === MAIN_KEY_PREFIX + MainKey.ALL)
					this.logUser = this._storageSvc.userUUID;
			}),
		);
		this.logUser = this._storageSvc.userUUID;
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});
	}

	showMember(event, role) {
		if (role === 'admin') {
			if (event.role !== 'admin') {
				this.members.map((e) => {
					if (e.email === event.email) {
						e.isAssign = true;
						e.role = 'admin';
						e.img.adminImg = 'assets/img/administrator-line-white.svg';
						e.img.leaderImg = 'assets/img/leader-line-gray.svg';
					}
				});
			} else {
				this.members.map((e) => {
					if (e.email === event.email) {
						e.isAssign = true;
						(e.role = ''),
							(e.img.adminImg = 'assets/img/administrator-line-gray.svg');
					}
				});
			}
		} else {
			if (event.role !== 'leader') {
				this.members.map((e) => {
					if (e.email === event.email) {
						e.isAssign = true;
						(e.role = 'leader'),
							(e.img.leaderImg = 'assets/img/leader-line-white.svg');
						e.img.adminImg = 'assets/img/administrator-line-gray.svg';
					}
				});
			} else {
				this.members.map((e) => {
					if (e.email === event.email) {
						e.isAssign = true;
						(e.role = ''),
							(e.img.leaderImg = 'assets/img/leader-line-gray.svg');
					}
				});
			}
		}
		const x = this.assignedROle.find((ele) => ele.email === event.email);
		if (x === undefined) {
			this.assignedROle.push(event);
		} else {
			this.assignedROle.splice(
				this.assignedROle.findIndex((a) => a.email === x.email),
				1,
			);
			this.assignedROle.push(event);
		}
		this.memberArrey = this.assignedROle;
	}
	searchKey(data: string) {
		this.search();
	}
	search() {
		this.members =
			this.searchText.value === ''
				? this.memberData1
				: this.memberData1.filter(
						(val) =>
							val.name
								.toLowerCase()
								.indexOf(this.searchText.value.toLowerCase()) >= 0,
					);
	}

	stepThreeSubmit() {
		let title: any;
		let groupDetails = JSON.parse(localStorage.getItem('groupDetails'));
		let newMemberRol: any = [];
		if (this.memberArrey.length !== 0) {
			this.memberArrey.map((ele) => {
				newMemberRol.push({
					uuid: ele.uuid,
					role: ele.role,
				});
			});
			const logUser = newMemberRol.find((ele) => ele.uuid === this.logUser);
			if (logUser === undefined) {
				newMemberRol.push({
					uuid: this.logUser,
					role: 'admin',
				});
			}
			const filteredArray = newMemberRol.filter((obj) => obj.role !== '');

			groupDetails.users = filteredArray;
		} else {
			let logUser = [{ uuid: this.logUser, role: 'admin' }];
			groupDetails.users = logUser;
		}
		const userAssign = groupDetails.users.find((user) => user.role === 'admin');
		delete groupDetails.isEnroll;
		if (userAssign) {
			this.groupSvc.createGroup(groupDetails).subscribe((res) => {
				if (res.success) {
					this.submitPop.emit(true);
					this.bsModalRef.hide();
					title = this.page?.createdGroup;
					this.successDialogBox(title);
					localStorage.removeItem('groupDetails');
					localStorage.removeItem('groupOrganizationUUID');
				}
			});
		}
	}

	successDialogBox(title: any) {
		Swal.fire({
			title: title,
			icon: 'success',
			confirmButtonColor: '#456790',
			confirmButtonText: this.page?.ok,
		});
	}

	ngOnDestroy(): void {
		this._subscriptions.unsubscribe();
	}
}
